import { Outlet } from 'react-router-dom';
import { ThemeProvider } from '@/app/providers/ThemeProvider';
import { CartDrawer } from '@/components/cart/CartDrawer';

/**
 * Main layout for the authenticated application.
 * This layout includes the ThemeProvider to apply app-wide theming.
 */
export const MainLayout = () => {
  return (
    <ThemeProvider>
      <div className="bg-secondary-100 dark:bg-secondary-900 min-h-screen">
        {/* You can add shared components like Header or Sidebar here */}
        <Outlet />
        <CartDrawer />
      </div>
    </ThemeProvider>
  );
};
